import { Video } from './../types/index';
import { VimeoUrlRegex, YouTubeUrlRegex } from '../constants/communities';

export const getYoutubeThumbnailLink = (
  youtubeUrl: string,
  encodeUrl: boolean
) => {
  if (!youtubeUrl) {
    return '';
  }
  const videoId = getYoutubeVideoId(youtubeUrl);
  if (!videoId) {
    return '';
  }
  const url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
  return encodeUrl ? encodeURI(url) : url;
};

export const getYoutubeVideoId = (youtubeUrl: string) => {
  if (youtubeUrl) {
    const regExp = YouTubeUrlRegex;
    const match = youtubeUrl?.match(regExp);
    return match && match[1].length === 11 ? match[1]?.trim() : '';
  }
  return '';
};

export const generateYoutubeEmbedURL = ({
  url,
  includePlayerParams
}: {
  url: string;
  includePlayerParams: boolean;
}) => {
  if (url) {
    const videoId = getYoutubeVideoId(url);
    const playerParams = '?rel=0&showinfo=0&autoplay=0&loop=1&modestbranding=1';
    if (videoId) {
      if (includePlayerParams) {
        return `https://www.youtube.com/embed/${videoId}${playerParams}`;
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return '';
  }
  return '';
};

export const getVimeoThumbnailLinkFromVideo = (
  video: Video,
  encodeUrl: boolean
) => {
  if (!video) {
    return '';
  }
  if (video?.info?.thumbnailUrl) {
    return video?.info?.thumbnailUrl;
  }
  return getVimeoThumbnailLinkFromURL(video?.vimeoUrl, encodeUrl);
};

export const getVimeoThumbnailLinkFromURL = (
  vimeoUrl: string,
  encodeUrl: boolean
) => {
  const videoId = getVimeoVideoId(vimeoUrl);
  if (!videoId) return '';

  const url = `https://vumbnail.com/${videoId}.jpg`;
  return encodeUrl ? encodeURI(url) : url;
};

export const getVimeoVideoId = (vimeoURL: string) => {
  if (isValidVimeoUrl(vimeoURL)) {
    return vimeoURL.split('com/')?.pop()?.trim() || '';
  }
  return '';
};

export const generateVimeoEmbedURL = ({ url }: { url: string }) => {
  const videoId = getVimeoVideoId(url);
  // Some videos have URL like "https://vimeo.com/762745827/08ff62bf07"
  // The video player url for this = "https://player.vimeo.com/video/762745827?h=08ff62bf07"
  const arr = videoId.split('/').filter(text => !!text);
  if (arr.length > 1) {
    return `https://player.vimeo.com/video/${arr[0]}?h=${arr[1]}&title=false`;
  }
  return videoId ? `https://player.vimeo.com/video/${arr[0]}?title=false` : '';
};

export const isValidYouTubeUrl = (url: string | undefined) =>
  YouTubeUrlRegex.test(url || '');

export const isValidVimeoUrl = (url: string | undefined) =>
  VimeoUrlRegex.test(url || '');

export const isVideoWithValidUrl = (video: Video) =>
  isValidYouTubeUrl(video?.youtubeUrl) || isValidVimeoUrl(video.vimeoUrl);

export const getVideoIframeUrl = ({
  url,
  includePlayerParams
}: {
  url: string;
  includePlayerParams: boolean;
}) => {
  if (isValidYouTubeUrl(url)) {
    return generateYoutubeEmbedURL({
      url: url,
      includePlayerParams: includePlayerParams
    });
  } else if (isValidVimeoUrl(url)) {
    return generateVimeoEmbedURL({ url });
  }
  return '';
};
